import { useQuery } from '@tanstack/react-query';

import { fetchPhrByUserId } from '@/shared/api/lotus';

import { userPhrKeys } from './keys';

export function userPhrQueryDefinition(userId: string) {
  return {
    queryKey: userPhrKeys.byUser(userId),
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchPhrByUserId(userId, signal),
    meta: {
      toast: {
        title: 'Could not load patient health data',
        description: 'Patient health data could not be fetched.',
      },
    },
  } as const;
}

/**
 * Fetch PHR for a user via React Query.
 */
export function useUserPhrQuery(userId: string | undefined) {
  return useQuery({
    ...userPhrQueryDefinition(userId ?? ''),
    enabled: !!userId,
  });
}
